import React, { useMemo, useState } from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';
import ModifyContainer from '../ModifyContainer';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';
import { callWebviewHandler, WebviewOperatorType } from 'utils/webview';
import { sanitizedData } from 'utils/editor';
import { normalizeTableTemporary } from 'utils/editorContent';

const ViewQuillContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;

  z-index: 1;

  width: 100%;
  padding: 0 20px;

  .ql-editor {
    padding: 0;
    font-size: 16px;
    font-weight: ${props => (props.$isMobile ? 500 : 400)};
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  table {
    * {
      box-sizing: border-box;
    }

    display: table;
    border-collapse: collapse;
    box-sizing: border-box;
    text-indent: initial;
    unicode-bidi: isolate;
    border-spacing: 2px;
    border-color: gray !important;

    &.ql-table-better {
      table-layout: fixed;
    }

    tbody {
      display: table-row-group;
      vertical-align: middle;
      unicode-bidi: isolate;
      border-color: inherit;
    }

    tr {
      display: table-row;
      vertical-align: inherit;
      unicode-bidi: isolate;
      border-color: inherit;
      -webkit-border-width: 1px;
      border-width: 1px !important;
    }

    td {
      display: table-cell;
      vertical-align: inherit;
      border: 1px solid #000;
      padding: 2px 5px;
      -webkit-border-width: 1px;
      border-width: 1px !important;

      > p {
        border-color: inherit;
      }
    }
  }

  img {
    max-width: 100% !important;
    width: 100%;
  }
`;

interface IntroduceContainerIProps {
  isMobile: boolean;
  editorValue: string;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const IntroduceContainer: React.FC<IntroduceContainerIProps> = props => {
  const { isMobile, editorValue, modifyValue, setModifyValue } = props;

  /*
    quill-table-better 가 표 앞에 두는 <temporary> 줄은 display: none 이라,
    거기에 갇힌 이미지는 재저장 전까지 소개글에서 보이지 않는다.
   */
  const normalizedValue = useMemo(
    () => normalizeTableTemporary(editorValue),
    [editorValue],
  );

  return (
    <ModifyContainer
      title="소개글"
      isSelected={!isMobile && modifyValue.modifyStatus === 'introduce'}
      onClick={() => {
        callWebviewHandler(WebviewOperatorType.EditorResizeHandler, {
          isVisible: true,
        });

        setModifyValue({ ...modifyValue, modifyStatus: 'introduce' });
      }}
      style={{ maxHeight: '370px', overflowY: 'scroll' }}
      isScrollable={true}
    >
      <ViewQuillContainer $isMobile={isMobile}>
        <div dangerouslySetInnerHTML={{ __html: normalizedValue }} />

        {/* <ReactQuill
          readOnly={true}
          theme="bubble"
          style={{ width: '100%', padding: 0 }}
          value={editorValue}
        /> */}
      </ViewQuillContainer>
    </ModifyContainer>
  );
};

export default IntroduceContainer;
